<div
    (mouseenter)="mouseEnterLeave(true)"
    (mouseleave)="mouseEnterLeave(false)"
    *ngIf="{value: visible$ | async} as visible"
    style="width:32px; height: 32px; display:flex; justify-content:center; align-items: center;">
    <div *ngIf="!visible.value &&
        !checkForm.get(alumno.id + '').value; else  checkbox">
        <div class="user-img-cont" *ngIf="alumno.imageUrl; else icono_usuario">
        <img src="{{alumno.imageUrl}}" class="user-img">
        </div>
        <ng-template #icono_usuario>
            <mat-icon>account_circle</mat-icon>
        </ng-template>
    </div>
    <ng-template #checkbox>
        <form [formGroup]="checkForm">
            <mat-checkbox [formControlName]="alumno.id" color="primary" [disableRipple]="true" (click)="$event.stopPropagation();"></mat-checkbox>
        </form>
    </ng-template>
</div>
